// @flow

import React from 'react';
import {connect} from 'react-redux';

import {requestVersionAcceptance} from 'app/acceptance/actions';

import {gt} from 'app/utils/i18n';
import {RequestApprovalPopover} from './RequestApprovalPopover';
import {AttachOverlay} from 'app/general/overlays';
import type {BasicUserType} from 'app/user/types';

type OwnProps = {|
  versionId: number,
  versionURL: string,
  contentType: 'procedure' | 'policy' | 'proceduregroup',
  managers: Array<BasicUserType>,
  versionApprovedAt: string | null,
  disabled: boolean,
  onApprovalRequest?: (
    requestApproveFunction: () => Promise<any>
  ) => Promise<any>,
  className?: string,
  refreshData: () => Promise<mixed>,
|};

type DispatchProps = {|
  requestVersionAcceptance: (
    number,
    string,
    string,
    Array<string>
  ) => Promise<any>,
|};

type Props = {|
  ...OwnProps,
  ...DispatchProps,
|};

class RequestApprovalButton extends React.Component<Props> {
  requestConfirmation = (message: string, recipients: Array<string>) => {
    const {
      contentType,
      versionId,
      onApprovalRequest,
      requestVersionAcceptance,
    } = this.props;

    const contentTypeMapping = {
      procedure: 'procedureversion',
      proceduregroup: 'processversion',
      policy: 'policyversion',
    };

    const requestCall = () =>
      requestVersionAcceptance(
        versionId,
        contentTypeMapping[contentType],
        message,
        recipients
      );

    return onApprovalRequest != null
      ? onApprovalRequest(requestCall)
      : requestCall();
  };

  render() {
    /* eslint-disable no-unused-vars */
    const {
      onApprovalRequest,
      contentType,
      versionId,
      managers,
      versionURL,
      versionApprovedAt,
      disabled,
      requestVersionAcceptance,
      refreshData,
      ...other
      /* eslint-enable no-unused-vars */
    } = this.props;

    return (
      <AttachOverlay
        trigger="click"
        overlay={({overlayProps}) => (
          <RequestApprovalPopover
            overlayProps={{...overlayProps, placement: 'bottom'}}
            managers={managers}
            contentType={contentType}
            onSubmit={this.requestConfirmation}
            refreshData={refreshData}
          />
        )}
      >
        {(handlers) => (
          <button
            disabled={versionApprovedAt != null || disabled}
            {...other}
            {...handlers}
          >
            {gt('Request Approval')}
          </button>
        )}
      </AttachOverlay>
    );
  }
}

export default connect<Props, OwnProps, _, DispatchProps, _, _>(null, {
  // $FlowFixMe - redux-thunk messes up with actions return types
  requestVersionAcceptance,
})(RequestApprovalButton);
